import React from 'react';
import './FormCustomerTerms.scss';
import Link from 'Components/Shared/Link/Link';
import Checkbox from 'Components/Shared/Checkbox/Checkbox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { FormattedMessage } from 'react-intl';

const localPathTerms = '/villkor';
const localPathIntegrityPolicy = '/villkor';

interface IProps {
  isChecked?: boolean;
  onChange: (isChecked: boolean) => void;
}

const FormCustomerTerms: React.SFC<IProps> = ({
  isChecked,
  onChange,
}) => (
    <Checkbox style='form-customer-terms' onChange={ onChange } value={ isChecked }>
      <FormattedText 
        style='sub-title medium-bold'
        displayName='Godkännande'
        formattedName='form.terms.header'
      />
      <FormattedMessage 
        id='form.terms.text'
        defaultMessage={ 
          `Jag har läst och godkänner Julius Biljettservice villkor. 
          För mer informationom hur vi behandlar dina personuppgifter 
          vid samtycke, se vår integritetspolicy.` 
        }
        values={ { 
          termsLink: (
            <Link 
              style='link' 
              localPath={ localPathTerms }
              displayName='köpvillkor'
              formattedName='global.purchaseterms'
            />
          ), 
          policyLink: (
            <Link 
              style='link' 
              localPath={ localPathIntegrityPolicy } 
              displayName='integritetspolicy'
              formattedName='global.integritypolicy'
            />
          ), 
        } }
      />
      <div className="refund">
        <FormattedMessage
          id='form.terms.refund'
        />
      </div>
    </Checkbox>
  );

export default FormCustomerTerms;


// WEBPACK FOOTER //
// ./src/components/FormCustomerTerms/FormCustomerTerms.tsx